import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { Send } from 'lucide-react';
import 'dayjs/locale/pt-br';

export default function SentMessagesCounter({ total, selectedMonth }) {
  return (
    <Paper
      variant="outlined"
      data-cy="sent-messages-counter"
      sx={{ borderRadius: 3, p: 2, display: 'flex', alignItems: 'center', gap: 2 }}
    >
      <Box
        sx={{
          color: 'success.main',
          bgcolor: 'action.hover',
          borderRadius: 2,
          p: 1.25,
          display: 'flex',
        }}
      >
        <Send size={22} />
      </Box>
      <Stack>
        <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
          {total}
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {total === 1 ? 'mensagem enviada' : 'mensagens enviadas'} em{' '}
          {selectedMonth.locale('pt-br').format('MMMM [de] YYYY')}
        </Typography>
      </Stack>
    </Paper>
  );
}

SentMessagesCounter.propTypes = {
  total: PropTypes.number.isRequired,
  selectedMonth: PropTypes.object.isRequired,
};
